import React, { useState } from 'react';
import classnames from 'classnames';
import { FleetCapabilities } from '@bringg/types';
import { Button } from '../../../components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Props {
	fleets: Fleet[];
	onSelect?(fleetId: string): void;
	selectedFleet?: Fleet;
}

interface Fleet {
	id: string;
	name: string;
	capabilities?: FleetCapabilities;
}

const FleetsList: React.FC<Props> = ({ fleets, onSelect, selectedFleet }) => {
	const [selected, setSelected] = useState<string>(selectedFleet?.id);
	const handleSelect = ({ id }: Fleet) => {
		if (id !== selected) {
			setSelected(id);
			onSelect(id);
		}
	};
	const isInteractive = !!onSelect;
	return (
		<div className="fleet-list">
			<div className="list-header">Fleets</div>
			<div className="fleet-list-content">
				{fleets.map(fleet => {
					const isGreen = fleet?.capabilities?.is_green;

					return (
						<Button
							key={fleet.id}
							className={classnames('fleet-list-content-item', {
								active: fleet.id === selected,
								'non-interactive': !isInteractive
							})}
							onClick={() => handleSelect(fleet)}
						>
							{fleet.name}
							{isGreen && (
								<BringgIcon iconName={BringgFontIcons.LeafEco} className="green-fleet-icon-container" />
							)}
						</Button>
					);
				})}
			</div>
		</div>
	);
};

export default FleetsList;
